import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Technologysec(props) {
  const [activeTab, setActiveTab] = useState(1);

  function displayTab(tabNumber) {
    setActiveTab(tabNumber);
  }

  return (
    <>
      <div className="tekgriping_section p-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
              <div className="example" data-text="Our Forte">
                <h2>Our Services</h2>
              </div>
              <p>
                Our team excels in providing adaptable and scalable serverless
                computing solutions that help businesses thrive advanced digital
                industry. We are the experts in serverless computing services
                with specialized options for cutting costs and enhancing
                operating efficiencies.
              </p>
            </Col>
            <Col xs={12} md={5} lg={5} xl={5} xxl={6} className="my-auto">
              <div className="tekgrip_flex">
                <div className="tekgrip_title">
                  <h5>
                    2X
                    <span>Increase in ROI</span>
                  </h5>
                </div>
                <div className="tekgrip_title">
                  <h5>
                    60%
                    <span>Increase in Efficiency</span>
                  </h5>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
              <h3
                onClick={() => {
                  displayTab(1);
                }}
                className={`tabs ${activeTab === 1 ? "active" : ""}`}
              >
                <div className="tab_namee">Backend-as-a-service (BaaS)</div>
              </h3>

              <h3
                onClick={() => {
                  displayTab(2);
                }}
                className={`tabs ${activeTab === 2 ? "active" : ""}`}
              >
                <div className="tab_namee">Platform-as-a-service (PaaS)</div>
              </h3>

              <h3
                onClick={() => {
                  displayTab(3);
                }}
                className={`tabs ${activeTab === 3 ? "active" : ""}`}
              >
                <div className="tab_namee">Function as a Service (FaaS)</div>
              </h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
        <Container className="h-100">
          <Row className={activeTab === 1 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Backend-as-a-service (BaaS)</h2>
                <p>
                  Our service approach is built around giving developers the
                  tools they need to handle backend tasks like data storage so
                  they can concentrate exclusively on creating the projects'
                  front ends. Our organization's primary goal is to reduce our
                  clients' time-to-market by optimizing and expediting the
                  development processes.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image ">
                <StaticImage
                  src="../../images/services/servless-computing/backend_img.webp"
                  alt="TekRevol"
                  className="slide-top"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={646}
                  height={841}
                />
              </div>
            </Col>
          </Row>
          <Row className={activeTab === 2 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Platform-as-a-service (PaaS)</h2>
                <p>
                  We offer a full Platform-as-a-Service (PaaS) solution that
                  gives developers quick access to a range of important tools
                  for developing and deploying applications on our cloud
                  platform. This includes everything from operating systems to
                  middleware, allowing for streamlined development experiences.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image">
                <StaticImage
                  src="../../images/services/servless-computing/platform_img.webp"
                  alt="TekRevol"
                  className="slide-top"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={646}
                  height={841}
                />
              </div>
            </Col>
          </Row>
          <Row className={activeTab === 3 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Function as a Service (FaaS)</h2>
                <p>
                  Our solution allows users to focus entirely on building
                  applications, while we manage the underlying infrastructure
                  difficulties. Whether it's processing data from a database,
                  responding to HTTP requests, or responding to changes in cloud
                  storage, our FaaS service handles these tasks very efficiently
                  and scalable.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image ">
                <StaticImage
                  src="../../images/services/servless-computing/function_img.webp"
                  alt="TekRevol"
                  className="slide-top"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={646}
                  height={841}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Technologysec;
